/**
 * @desc store module for general purpose
 */

import Vue from 'vue'
import Vuex from 'vuex'
import snackbar from './modules/snackbar'
import auth from './modules/auth'
import users from './modules/users'
import packages from './modules/packages'
import categories from './modules/categories'
import speakers from './modules/speakers'
import sponsors from './modules/sponsors'
import galleries from './modules/galleries'
import venue from './modules/venue'
import statusDisplayName from './modules/statusDisplayName'
import killerFeatureDisplaySettings from './modules/killerFeatureDisplaySettings'
import formInterpritation from './modules/formInterpritation'
import invitationSingle from './modules/invitationSingle'
import vipInvitation from './modules/vipInvitation'
import vipAttendeeType from './modules/vipAttendeeType'
import regularAttendeeSettings from './modules/regularAttendeeSettings'
import regularAttendeeType from './modules/regularAttendeeType'
import featuredAttendee from './modules/featuredAttendee'
import uploadTable from './modules/upload'
import blitz from './modules/blitz'
import tag from './modules/tag'
import vipAttendeeSettings from './modules/vipAttendeeSettings'
import * as types from './mutation-types'
import display from './modules/display'
import nominees from './modules/nominees'
import promoCodes from './modules/promoCodes'
import attendeeMutual from './modules/attendeeMutual'
import listing from './modules/listing'
import killerFeatureSettings from './modules/killerFeatureSettings'
import voucherPage from './modules/voucherPage'
import signalr from './modules/signalr'
import emailNotificationSettings from './modules/emailNotificationSettings'
import invoices from './modules/invoices'
import { pathOr } from 'ramda'
// import * as types from './mutation-types'

//  excel-loader
import importExcel from './modules/importExcel'

/* Import store modules */
import currentForm from './modules/currentForm'
import locations from './modules/locations'
import agendaSettings from './modules/agenda-settings'
import agendaSessions from './modules/agenda-sessions'
import nominationsCategories from './modules/nominations-categories'
import emailTemplates from './modules/emailTemplates'
import regularAttendee from './modules/regularAttendee'
import vipAttendee from './modules/vipAttendee'
import attendeeReminders from './modules/attendeeReminders'
// import account from './modules/account'
// import auth from './modules/auth'
// import register from './modules/register'
import generalSettings from './modules/general-settings'
import staticContent from './modules/static-content'
import testimonials from './modules/testimonials'
import videos from './modules/videos'
import banners from './modules/banners'
import photoGallery from './modules/photo-gallery'
import cookiesSettings from './modules/cookies-settings'
import lastYearTestimonials from './modules/lastYearTestimonials'
import google from './modules/google'
import awardsSettings from './modules/awards-settings'
import awardsReminders from './modules/awards-reminders'
import badgeExport from './modules/badge-export'
import registrationVipInvitation from './modules/registrationVipInvitation.js'
import allAttendee from './modules/attendee'
import attendeesMessages from './modules/attendees-messages.js'
import emailTemplatesSettings from './modules/emailTemplatesSettings'
import attendeeVoteReminders from './modules/attendee-vote-reminders'
import attendeesAllMessages from './modules/attendees-all-messages'
import sendGrid from './modules/sendGrid'
import mailChimp from './modules/mail-chimp'
import blackList from './modules/blackList'
import blockedIps from './modules/blockedIps'
import mapLocations from './modules/map-locations'

import applyAnalytic from '../utils/applyAnalytic'

/* Plug in Vuex store */
import { storeLogger } from '../../plugins/logger'
import { eventToAnalytic } from './plugins/google-analytics'

Vue.use(Vuex)

export const state = {
  globalSpinnerVisible: false
}

export const getters = {
  getSpinnerVisibilityStatus: state => state.globalSpinnerVisible,
  getGoogleAnalyticsCodeString: state => pathOr('', ['generalSettings', 'settings', 'globalSetting', 'googleAnalyticsCodeString'], state)
}

export const actions = {}

export const mutations = {
  [types.SET_SPINNER_STATUS] (state, status) {
    state.globalSpinnerVisible = status
  }
}

const vuexPlugins = [storeLogger]
if (applyAnalytic) {
  vuexPlugins.push(eventToAnalytic)
}

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  plugins: vuexPlugins,
  modules: {
    auth,
    snackbar,
    users,
    galleries,
    currentForm,
    formInterpritation,
    display,
    sponsors,
    blitz,
    uploadTable,
    packages,
    categories,
    locations,
    nominees,
    agendaSettings,
    agendaSessions,
    vipInvitation,
    vipAttendeeType,
    attendeeReminders,
    statusDisplayName,
    killerFeatureDisplaySettings,
    vipAttendeeSettings,
    regularAttendeeSettings,
    regularAttendeeType,
    regularAttendee,
    speakers,
    tag,
    nominationsCategories,
    emailTemplates,
    generalSettings,
    promoCodes,
    vipAttendee,
    staticContent,
    importExcel,
    featuredAttendee,
    testimonials,
    photoGallery,
    videos,
    banners,
    cookiesSettings,
    lastYearTestimonials,
    google,
    attendeeMutual,
    awardsSettings,
    awardsReminders,
    killerFeatureSettings,
    listing,
    invitationSingle,
    voucherPage,
    badgeExport,
    registrationVipInvitation,
    emailNotificationSettings,
    allAttendee,
    attendeesMessages,
    invoices,
    emailTemplatesSettings,
    attendeeVoteReminders,
    attendeesAllMessages,
    sendGrid,
    mailChimp,
    blackList,
    blockedIps,
    mapLocations,
    signalr,
    venue
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js